import { auth } from '../../firebase';
import { MYKYC_API_BASE } from '../../config/api';

const base = (process.env.REACT_APP_FATCA_API_BASE || MYKYC_API_BASE).replace(/\/+$/, '');
export async function requestFatca(path, { body, file, signal } = {}) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Sign in to access FATCA.');
  let response;
  try {
    response = await fetch(`${base}/fatca/${path}`, {
      method: (body || file) ? 'POST' : 'GET', signal, cache: 'no-store',
      headers: { Authorization: `Bearer ${token}`, ...(file ? {'Content-Type':'text/csv'} : body ? {'Content-Type':'application/json'} : {}) },
      ...(file ? {body:file} : body ? {body:JSON.stringify(body)} : {}),
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new Error('The FATCA API could not be reached. Please retry.');
  }
  const data = await response.json().catch(()=>null);
  if (!response.ok || !data) throw new Error(data?.error || 'The FATCA API returned an invalid response.');
  return data;
}
